module.exports = __webpack_public_path__ + "img/Ila_Logo.88bd6023.png";